/**
 * Retrieves metadata form fields from the given container.
 * @param {HTMLElement|NodeList} form_container - Container element(s) for the form.
 * @returns {Object} An object of metadata key/value pairs.
 */
export function get_metadata_form_fields(form_container, data_hub_instance = window?.data_hub) {
    if (!form_container) {
        form_container = data_hub_instance?.form_containers
                        || document.querySelectorAll(data_hub_instance?.form_container_selector
                        || '.data-hub-form-container');
    }

    if (!data_hub_instance || !data_hub_instance.form_metadata_form_field_selector) {
        return {};
    }

    let metadata = {};

    // Normalize to iterable: wrap single element in array
    const containers = (form_container instanceof NodeList || form_container.forEach)
        ? form_container
        : [form_container];

    containers.forEach(container => {
        const fields = container.querySelectorAll(data_hub_instance.form_metadata_form_field_selector);
        if (fields && fields.length > 0) {
            fields.forEach(field => {
                const key = field.id || field.name;
                if (key) {
                    metadata[key] = field.value;
                }
            });
        }
    });

    return metadata;
}
